




import { Component } from "vue-property-decorator"
import Preview from "./Preview.vue"

@Component({
  components: { Preview },
})
export default class SpPreview extends Preview {
  public created(): void {
    const type = "sp"
    const message = "こちらにアクセス"

    this.postPreview(type, message)
  }
}
